const daysOfWeek = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];

function isBusinessHours(operating_hours) {
  const now = new Date();
  const currentDay = daysOfWeek[now.getDay()];
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();

  if (operating_hours?.hasOwnProperty(currentDay)) {
    const { open, close } = operating_hours[currentDay];
    const [openHour, openMinute] = open.split(":").map(Number);
    const [closeHour, closeMinute] = close.split(":").map(Number);
    const afterOpen = currentHour > openHour || (currentHour === openHour && currentMinute >= openMinute);
    const beforeClose = currentHour < closeHour || (currentHour === closeHour && currentMinute <= closeMinute);
    return afterOpen && beforeClose;
  }
  return false;
}

/**
 * @param {string} operating_status  - e.g. restaurant?.restaurant_operating_status
 * @param {string} operating_settings - e.g. settings?.restaurant_operating_status (global app setting)
 * @param {object|null} operating_hours - e.g. restaurant?.restaurant_operating_time
 */
export function isRestaurantOpen(operating_status, operating_settings, operating_hours) {
  if (operating_status === "open" && operating_settings === "available") {
    return operating_hours === null || operating_hours === undefined || isBusinessHours(operating_hours);
  }
  return false;
}
